import { render } from "./Distribution.vue?vue&type=template&id=1cb6d91e&scoped=true&ts=true"
import script from "./Distribution.vue?vue&type=script&lang=ts"
export * from "./Distribution.vue?vue&type=script&lang=ts"

import "./Distribution.vue?vue&type=style&index=0&id=1cb6d91e&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb6d91e"]])

export default __exports__